import React, {useState} from 'react';
import {useField} from 'formik';
import { DateInput } from '@mantine/dates';
import moment from "moment";

const MantineDateField = (props) => {
    const {label, name} = props;
    const [field, meta, helpers] = useField(name);
    const [value, setValue] = useState(field.value === "" ? "" : moment(field.value, 'YYYY-MM-DD').toDate());
    const {setValue: setFieldValue, setTouched} = helpers;

    return (
        <DateInput
            {...props}
            label={label}
            value={value}
            onChange={(e) => setValue(moment(e, 'DD/MM/YYYY').toDate())}
            onBlur={() => {
                setFieldValue(value)
                setTouched(name, false)
            }}
            dateParser={(dateString) => moment(dateString, 'DD/MM/YYYY').toDate()}
            error={meta.error && meta.touched && <div>{meta.error}</div>}
            allowFreeInput
            locale="es"
            placeholder="dd/mm/yyyy"
            inputFormat="DD/MM/YYYY"
            valueFormat="DD/MM/YYYY"
        />
    );
};

export default MantineDateField;
